import store from './store';
import uuid from './uuid';
import { smoothScroll } from './common/smoothScroll';
import TAnimation from './tquery';
import { DOMContentLoadedCookieHandler, setWindowCookieActions } from './cookie-policy-setup';
import { getSingleAnswer, handleQuizProcess } from './quiz-handler';
import { getCustomerUuid } from './common-helpers/getCustomerUuid';
import { getHost } from './common-helpers/getHost';
import { setAnswer } from './common-helpers/setAnswer';
import { appendCidToMenuLinks } from './common-helpers/appendCidToMenuLinks';

window.store = store;

if (window.NodeList && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = Array.prototype.forEach;
}

window.getCustomerUuid = getCustomerUuid;

window.onload = function () {
  store.storeMarketingInfo();
  store.storeCustomerUuid(getCustomerUuid() || uuid.v4());
  appendCidToMenuLinks();
};

window.setAnswer = setAnswer;

window.getHost = getHost;

export const homePage = {
  infoModalAnimation: null,
  setActiveStateToBtn() {
    const button = document.querySelectorAll('.js-active-control');

    function removeAllActive() {
      [...button].forEach(element => {
        const toRemoveActive = element.querySelectorAll('.js-active');
        [...toRemoveActive].forEach(e => e.classList.remove('opacity-100'));
      });
    }

    [...button].forEach(element => {
      element.addEventListener('click', e => {
        removeAllActive();
        const toAddActive = e.currentTarget.querySelectorAll('.js-active');
        [...toAddActive].forEach(e => e.classList.toggle('opacity-100'));
      });
    });
  },
  getQueryVariable(variable) {
    const query = window.location.search.substring(1);
    const vars = query.split('&');

    for (let i = 0; i < vars.length; i++) {
      const pair = vars[i].split('=');

      if (pair[0] == variable) {
        return pair[1];
      }
    }

    return false;
  },
  setSimpleTemplateTheme() {
    let theme = store.getAnswers().bodyClass || store.get('bodyClass') || 'woman-theme';
    if (document.querySelector('.js-simple-template')) {
      document.body.classList.remove('woman-theme', 'men-theme');
      try {
        document.body.classList.add(theme);
      } catch (e) {
        document.body.classList.add('woman-theme');
      }
    }
  },
  dietAnswer(obj) {
    const storedBodyClassData = store.getAnswers().bodyClass || store.get('bodyClass');

    if (obj.classList.contains('bodyClass') && window.location.pathname == '/') {
      let bodyClass = obj.dataset.bodyClassValue;

      if (bodyClass != storedBodyClassData) {
        window.setAnswer('bodyClass', bodyClass);
      }
    }

    this.setSimpleTemplateTheme();

    window.setAnswer(obj.dataset.key, parseInt(obj.dataset.value));

    if (obj.dataset.href) {
      window.location.href = window.getHost() + obj.dataset.href;
    }
  },
  handleLandingQuery() {
    const parameters = window.location.search.substring(1).split('&');
    const data = {};
    const x = document.createElement('div');
    parameters.forEach(function (value) {
      const parameter = value.split('=');
      data[parameter[0]] = decodeURI(parameter[1]);
      x.setAttribute('data-' + parameter[0], decodeURI(parameter[1]));
    });
    x.classList.add('bodyClass');
    this.dietAnswer(x);
  },
  handleScrollBtnClick(e) {
    e.preventDefault();
    const positionOfTarget = document.querySelector(e.currentTarget.getAttribute('href')).offsetTop - 100;
    smoothScroll(positionOfTarget, 2000);
  },
  openModal(e) {
    e.preventDefault();
    this.infoModalAnimation.fadeIn();
    document.querySelector('body').style.overflow = 'hidden';
  },
  closeModal(e) {
    e.preventDefault();
    this.infoModalAnimation.fadeOut();
    document.querySelector('body').style.overflow = '';
  },
  handleDOMContentLoaded() {
    this.getQueryVariable('landing') && this.handleLandingQuery();

    setWindowCookieActions();
    DOMContentLoadedCookieHandler();

    const callback = this.dietAnswer.bind(this);
    document.querySelectorAll('.dietAnswer').forEach(function (v) {
      v.addEventListener('click', function (e) {
        handleQuizProcess(getSingleAnswer(e.currentTarget), e.currentTarget, callback);
      });
    });

    const linkContainers = document.querySelectorAll('#ScrollToQuiz');
    linkContainers.forEach(link => {
      const scrollButton = link.querySelector('a');
      scrollButton?.addEventListener('click', this.handleScrollBtnClick);
    });

    const backButton = document.querySelector('.js-back-button');
    if (backButton) {
      backButton.addEventListener('click', function () {
        history.back();
      });
    }

    const infoModal = document.querySelector('.js-simple-modal');
    if (infoModal) {
      this.infoModalAnimation = new TAnimation(infoModal);

      const modalTrigger = document.querySelector('.js-modal-info');
      const closeModalBtn = document.querySelector('.js-modal-close');

      modalTrigger.addEventListener('click', this.openModal.bind(this));
      closeModalBtn.addEventListener('click', this.closeModal.bind(this));
    }

    this.setSimpleTemplateTheme();
    this.setActiveStateToBtn();
  },
};

document.addEventListener('DOMContentLoaded', () => {
  homePage.handleDOMContentLoaded();
});
